import React, {useRef} from 'react'
import {createPortal} from 'react-dom'
import styled from '@emotion/styled'

import useBodyScrollLock from '@vio/atlas/Overlay/useBodyScrollLock'
import {cssTheme} from '@vio/atlas/themes'

const BackgroundElement = styled.div`
  position: fixed;
  z-index: 102;
  inset: 0;
  isolation: isolate;
  background: ${cssTheme.colors.background.neutral.overlay};
`

export const CookieBannerBackground = () => {
  const bgRef = useRef<HTMLDivElement>(null)
  useBodyScrollLock({ref: bgRef})

  const osanoWindowEl = document.querySelector('.osano-cm-window')
  if (!osanoWindowEl) return null
  // we need to inject this component directly into osano-cm-window to avoid
  // other overlays like exit popup and searchbox on srp being on top of this
  return createPortal(<BackgroundElement ref={bgRef} />, osanoWindowEl)
}
